export const TOKEN_QUERY_KEY = 'at'
export const INFOGRAPH_URL = 'https://infograph.venngage.com'
